import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import {
  disableNativePush,
  enableNativePush,
  getNativePushSubscription,
  nativePushSupported,
} from "../common/native_push";

const NativePushControl = () => {
  const [supported] = useState(nativePushSupported());
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (supported) getNativePushSubscription().then((value) => setSubscribed(Boolean(value)));
  }, [supported]);

  const toggle = async () => {
    setBusy(true);
    try {
      if (subscribed) {
        await disableNativePush();
        setSubscribed(false);
        message.success("Notifications disabled");
      } else {
        await enableNativePush();
        setSubscribed(true);
        message.success("Notifications enabled");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || error.message || "Unable to update notifications");
    } finally {
      setBusy(false);
    }
  };

  if (!supported) return null;

  return (
    <div className="notifications-box" style={{ marginBottom: 20 }}>
      <h3>Browser notifications</h3>
      <p>Receive important Konnect updates even when this page is not open.</p>
      <Button type={subscribed ? "default" : "primary"} loading={busy} onClick={toggle}>
        {subscribed ? "Disable notifications" : "Enable notifications"}
      </Button>
    </div>
  );
};

export default NativePushControl;
